import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { LazyService } from '../../../../services/lazy.service';
declare var __tableauApiServiceRegistry:any;

@Component({
    selector: 'dashboard-tableau',
    templateUrl: './tableau.component.html',
    styleUrls: ['./tableau.component.scss'],
    standalone: false
})
export class TableauComponent implements OnInit {
  @Input() data: any;
  
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  
  config: any = {};
  constructor(private baseService: BaseService, 
    private appService: AppService, 
    private lazyService: LazyService, 
    private loader: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    public dialogService:DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService:UtilService,
    public dashBoardService:DashboardService
    ) {
  }

  ngOnInit() {
    console.log("this.data===>",this.data);
    if(typeof __tableauApiServiceRegistry !== 'undefined'){
      this.build();
    }else{
      this.lazyService.loadScript("/assets/js/tableau.embedding.3.latest.min.js",true).then(()=>{
        this.build();
      })
    }
  }

 
  build(){
    this.loader.showSpinner();
    this.dashBoardService.getWidgetData(this.data.widget_id,(data)=>{
      this.loader.hideSpinner();
      this.config.data = data;
      this.config.data.token = this.route.snapshot.queryParams.token;
      console.log("config===>",this.config.data)
      
      this.dashBoardService.getDashboardUrl(data.id,'tableau',null,(token)=>{
        if(token){
          this.config.data.token = token;
        }
      });
      
    })
  }

 
 
  
}
